<div class="btn-group" [sq-action-buttons]="{items: actions, size: size, style: style, rightAligned: rightAligned}"></div>